import ListItem from '../../utils/ListItem';

function AirfieldListItem(props) {
  const dates = [props.arrival, props.depart].filter(Boolean).join(' → ');
  return (
    <ListItem
      primary={props.name}
      secondary={dates || null}
    />
  );
}

export default AirfieldListItem;
